import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/headshot.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/inline-highlight.module.css");
